import Vue from "vue";
import Router from "vue-router";
import home from "@/components/home";

import layout from "@/components/layout";
import profile from "@/components/profile";

import clone from "@/components/clone";
import consum from "@/components/consum";
import create from "@/components/create";
import works from "@/components/works";
import login from "@/components/login";


Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   redirect: '/home'
    // },
    {
      path: "/",
      component: layout,
      redirect: "/home",
      meta: {
        title: "首页",
        keepAlive: false,
      },
      children: [
        {
          path: "/home",
          name: "Home",
          component: home,
          meta: { title: "首页", keepAlive: false },
        },
        {
          path: "/create",
          name: "create",
          component: create,
          meta: { title: "开始创作", keepAlive: false },
        },
        {
          path: "/profile",
          name: "profile",
          component: profile,
          meta: { title: "数字形象", keepAlive: false },
        },
        {
          path: "/clone",
          name: "clone",
          component: clone,
          meta: { title: "声音克隆", keepAlive: false },
        },

        {
          path: "/works",
          name: "works",
          component: works,
          meta: { title: "我的作品", keepAlive: false },
        },
        {
          path: "/consum",
          name: "consum",
          component: consum,
          meta: { title: "消费中心", keepAlive: false },
        },

        {
          path: "/explosiveAnalysis",
          name: "explosiveAnalysis",
          component: () => import("../components/explosive/explosiveAnalysis"),
          meta: { title: "超级复刻", keepAlive: false },
        },
        {
          path: "/explosiveAnalysis/video",
          name: "explosiveVideo",
          component: () => import("../components/explosive/explosiveVideo"),
          meta: { title: "视频解析", keepAlive: false },
        },
        {
          path: "/explosiveAnalysis/user",
          name: "explosiveUser",
          component: () => import("../components/explosive/userAnalysis"),
          meta: { title: "账号解析", keepAlive: false },
        },
        {
          path: "/explosiveAnalysis/character",
          name: "explosiveCharacter",
          component: () => import("../components/explosive/character"),
          meta: { title: "我的人设", keepAlive: false },
        },
        {
          path: "/explosiveAnalysis/project",
          name: "explosiveProject",
          component: () => import("../components/explosive/project"),
          meta: { title: "我的产品", keepAlive: false },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: { title: "登录", keepAlive: false },
    },
    {
      path: "/protocol",
      name: "protocol",
      component: () => import("../components/protocol.vue"),
      meta: { title: "协议", keepAlive: false },
    },
  ],
  mode: "hash",
});



// WEBPACK FOOTER //
// ./src/router/index.js